<template>
  <div>
      <layout-one>
          <el-form :model="form" label-width="160px" :inline="true" ref="form" :rules="rules">
                <!-- ------- 基本信息 ------- -->
                <div class="section">
                    <h4>基本信息</h4>
                    <!-- 考试批次 -->
                    <div class="sectionBox">
                        <el-form-item label="考试批次">
                            <span>{{planCode}}</span>
                        </el-form-item>
                    </div>
                    <!-- 考试批次名称 -->
                    <div class="sectionBox">
                        <el-form-item label="考试批次名称" prop="name">
                            <el-input placeholder="请输入" v-model="form.name" :disabled="true"></el-input>
                        </el-form-item>
                    </div>
                    <!-- 报名人工审核 -->
                    <div class="sectionBox">
                        <el-form-item label="报名人工审核" :required="true">
                            <!-- 报名人工审核 button -->
                            <el-radio-group v-model="form.form_needAudit" :disabled="true">
                                <el-radio-button label="1" class="examType">一级人工审核</el-radio-button>
                                <el-radio-button label="2" class="examType">二级人工审核</el-radio-button>
                                <el-radio-button label="0" class="examType">不做人工审核</el-radio-button>
                            </el-radio-group> 
                        </el-form-item>
                    </div>
                    <!-- 新增考点场次 -->
                    <div class="sectionBox">
                        <el-form-item label="报名选考点场次">
                            <el-switch
                                v-model="form.optionalSession"
                                :active-value="1"
                                :inactive-value="0"
                                :disabled="true"
                            ></el-switch>
                        </el-form-item>
                    </div>
                    <!-- 是否下载准考证 -->
                    <div class="sectionBox">
                        <el-form-item label="下载准考证">
                            <el-switch
                                v-model="form.downloadEntrance"
                                :active-value="1"
                                :inactive-value="0"
                                :disabled="true"
                            ></el-switch>
                        </el-form-item>
                    </div>
                    <!-- 是否开启缴费 -->
                    <div class="sectionBox">
                        <el-form-item label="是否开启缴费">
                            <el-switch
                                v-model="form.isPay"
                                :active-value="1"
                                :inactive-value="0"
                                :disabled="true"
                            ></el-switch>
                        </el-form-item>
                    </div>
                </div>

                <!-- ------- 时间设置 ------- -->
                <div class="section mt20">
                    <h4>时间设置</h4>
                    <div class="sectionBox">
                        <el-form-item label="报名起止时间">
                            <el-date-picker
                                :value-format="dataFormat"
                                v-model="form.beginSign"
                                :disabled="true"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                            至
                            <el-date-picker
                                :value-format="dataFormat"
                                v-model="form.endSign"
                                :disabled="true"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!-- 添加 初审截止时间 -->
                    <div class="sectionBox" v-if="hiddenPrimaryEndAudit">
                        <el-form-item label="初审截止时间" prop="primaryEndAudit">
                            <el-date-picker
                                :disabled="true"
                                :value-format="dataFormat"
                                v-model="form.primaryEndAudit"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!-- 终审截止时间 -->
                    <div class="sectionBox" v-if="hiddenEndAudit">
                        <el-form-item :label="endAuditLabel">
                            <el-date-picker
                                :value-format="dataFormat"
                                v-model="form.endAudit"
                                :disabled="true"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!-- 缴费起止时间 -->
                    <div class="sectionBox" v-if="form.isPay == 1">
                        <el-form-item label="缴费起止时间" prop="startPay">
                            <el-date-picker
                                :disabled="true"
                                :value-format="dataFormat"
                                v-model="form.startPay"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            至
                        </el-form-item>
                        <el-form-item label="" prop="endPay">
                            <el-date-picker
                                :disabled="true"
                                :value-format="dataFormat"
                                v-model="form.endPay"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!-- 准考证打印开始时间 -->
                    <div class="sectionBox">
                        <el-form-item label="准考证打印开始时间" v-if="form.downloadEntrance">
                            <el-date-picker
                                :value-format="dataFormat"
                                v-model="form.beginEntrance"
                                :disabled="true"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!-- 考试起止时间 -->
                    <div class="sectionBox">
                        <el-form-item label="考试起止时间">
                            <el-date-picker
                                :value-format="dataFormat"
                                v-model="form.beginExam"
                                :disabled="true"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                            至
                            <el-date-picker
                                :value-format="dataFormat"
                                v-model="form.endExam"
                                :disabled="true"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!-- 成绩查询开始时间 -->
                    <div class="sectionBox">
                        <el-form-item label="成绩查询开始时间">
                            <el-date-picker
                                :value-format="dataFormat"
                                v-model="form.beginScoreCheck"
                                :disabled="true"
                                type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <!-- ------- 课程设置 ------- -->
                <div class="section mt20" >
                    <h4>课程设置</h4>
                    <div class="sectionBox">
                        <el-form-item label="考试科目选择">
                            <div class="stationBox">
                                <el-checkbox-group v-model="form.form_courseIdList" @change="handleCheckedChange">
                                    <el-checkbox disabled  v-for="course in courseData" :label="course.id" :key="course.id">{{course.name}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <!-- ------- 费用设置 ------- -->
                <div class="section mt20" v-if="form.isPay == 1">
                    <h4>费用设置</h4>
                    <!-- (1) 缴费方式 -->
                    <div class="sectionBox">
                        <el-form-item label="缴费方式" :required="true">
                            <el-radio-group v-model="form.payType" :disabled="true">
                                <el-radio-button label="1" class="examType">线上缴费</el-radio-button>
                                <el-radio-button label="2" class="examType">线下缴费</el-radio-button>
                            </el-radio-group> 
                        </el-form-item>
                    </div>
                    <!-- (2) 选择的课程费用 -->
                    <div class="sectionBox" v-show="form.payType && PayMentInfo.needPayCourse.length > 0">
                        <el-form-item label="课程费用">
                            <div class="stationBox">
                                <div  v-for="course in PayMentInfo.needPayCourse" :key="course.id" style="margin-bottom: 8px;">
                                    <el-form-item :label="course.name" >
                                        <el-input placeholder="请输入" v-model.number="PayMentInfo.PayCourse[course.id]" disabled>
                                            <template slot="suffix">元&nbsp;&nbsp;</template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                    <!-- (3) 线下缴费 - 二维码 -->
                    <div class="sectionBox" v-if="form.payType == 2">
                        <el-form-item label="线下缴费二维码">
                            <el-upload
                                action=""
                                :disabled="true"
                                class="avatar-uploader dinb"
                                :show-file-list="false"
                            >
                                <img v-if="payInfo.imageUrl" :src="payInfo.imageUrl" class="avatar" />
                                <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                            </el-upload>
                        </el-form-item>
                    </div>
                    <!-- (4) 缴费说明 -->
                    <div class="sectionBox" v-if="form.payType == 2">
                        <el-form-item label="缴费说明">
                            <el-input
                                class="textarea"
                                type="textarea"
                                :disabled="true"
                                v-model="payInfo.paymentText"
                                placeholder="请添加缴费说明，以小写分号;分隔多条说明，可预览查看"
                            ></el-input>
                            <div class="col_blue cp pr preBtn">
                                <span>预览</span>
                                <div class="codePreview col_black">
                                <div class="picArea">
                                    <img v-if="payInfo.imageUrl" :src="payInfo.imageUrl" alt="" />
                                </div>
                                <div class="payContent">
                                    <p v-for="(item, index) in payRemarkList" :key="index"> {{ `${index + 1}.${item}` }} </p>
                                </div>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <!-- 报名须知 -->
                <div class="section mt20">
                    <h4>报名须知</h4>
                    <div class="sectionBox">
                        <el-form-item label="报名须知">
                            <div class="editor" v-html="form.signRemark"></div>
                        </el-form-item>
                    </div>
                </div>

                <!-- 准考证设置根据"下载准考证选项"显示 -->
                <div class="section mt20" v-if="form.downloadEntrance">
                    <h4>准考证设置</h4>
                    <div class="sectionBox">
                        <el-form-item label="准考证">
                            <el-button round plain @click="leftShow" v-if="isUploadTicket">预览准考证</el-button>
                            <template v-else> 未上传准考证模板 </template>
                        </el-form-item>
                    </div>
                </div>
                
          </el-form>
      </layout-one>
  </div>
</template>
<script>
const EditorConfig = {
    // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 200,
        // 初始容器宽度
        initialFrameWidth: '90%',
        // 元素路径
        elementPathEnabled : false,
        // 启用自动保存
        enableAutoSave: false,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！部署在国外的服务器，如果无法访问，请自备梯子）
        // serverUrl: 'http://35.201.165.105:8000/controller.php',
        // serverUrl: '/api/resources/ots/student/ueditorjsp/jsp/controller.jsp?name=cate',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/',
        // 编辑器图标设置
        // toolbars: [
        //     [
        //         "source",
        //         "|",
        //         "bold",
        //         "italic",
        //         "underline",
        //         "|",
        //         'simpleupload',
        //         'insertimage',
        //         "|"
        //     ]
        // ],
        toolbars: [
            [
                'undo', 'redo', '|',
                'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', '|', 
                'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', '|',
                'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', 
                // 'removeformat', 'formatmatch','blockquote', ,  '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter' 
            ]
        ]
}
import { mapMutations } from 'vuex'
import { getSelectCourse } from '@/http/modules/baseSet/course'
import { addPlanFn, editPlanFn, getPlanCodeFn, getSinglePlan } from '@/http/modules/examSet/examBatch'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name: 'checkBatch',
    components: { VueUeditorWrap },
    data () {
        return {
            /* ** 缴费配置 ** */
            PayMentInfo: {
                // (1) 需要缴费的课程列表
                needPayCourse: [],
                // (2) 存储配置的缴费课程
                PayCourse: {},
            },

            // 初审截止 表单是否显示
            hiddenPrimaryEndAudit: false,
            // 终审/审核 截止时间文字描述
            endAuditLabel : "审核截止时间",
            // 终审/审核 表单是否显示
            hiddenEndAudit: true,

            isUploadTicket: false,
            entranceFilepath: '',
            isEdit: false,
            saveMethods: 'addOrEdit',
            backMethods: 'goIndex',
            planCode: '',
            dataFormat: 'yyyy-MM-dd HH:mm:ss',
            courseScopeText: '',
            aaa: '',
            form: {
                name: '',
                isPay: '',
                payType: '',
                form_needAudit: "1",
                form_needIpCheck: false,
                money: '',
                beginSign: '',
                endSign: '',
                endAudit: '',
                startPay: '',
                endPay: '',
                beginEntrance: '',
                beginExam: '',
                endExam: '',
                beginScoreCheck: '',
                signRemark: '',
                examRemark: '',
                form_courseIdList: [],
                primaryEndAudit: "",
                // 报名选考点场次
                optionalSession: '',
                // 下载准考证
                downloadEntrance: '',

            },
            rules: {
                name: [
                    {required: true, message: '请填写考试批次名称', trigger: 'blur'},
                    { min: 1, max: 50, message: '最多可输入50个字', trigger: 'blur' }
                ],
                money: [
                    { type: 'number', message: '收费必须为数字值', trigger: 'blur'}
                ]
            },
            courseData: [],
            editorConfig: {},
            // 缴费二维码,缴费说明,缴费方式.
            payInfo:{
                imageUrl:'',
                onlinePayment: '',
                paymentText: ''
            }
        }
    },
    computed: {
        payRemarkList() {
            return this.payInfo.paymentText
            ? this.payInfo.paymentText.split(";")
            : null;
        },
    },
    created () {
        this.initStatus()
        this.editorConfig = EditorConfig
        // this.initPlanCode()
        this.initCourseData()
    },
    methods: {
        /*********************************
         * @this 报名人工审核方式按钮改变事件
         *********************************/
        examTypeChange(val){
            if (val == 1) {
                // 1. 是否隐藏 初审截止时间 输入框
                this.hiddenPrimaryEndAudit = false;
                // 2. 是否隐藏 终审/审核截止时间 输入框
                this.hiddenEndAudit = true;
                // 3. 修改 审核/终审截止时间 文字描述
                this.endAuditLabel = "审核截止时间";
            } else if ( val == 2 ) {
                this.hiddenPrimaryEndAudit = true;
                this.hiddenEndAudit = true;
                this.endAuditLabel = "终审截止时间";
            } else if ( val == 0 ) {
                this.hiddenPrimaryEndAudit = false;
                this.hiddenEndAudit = false;
                this.endAuditLabel = "";
            }
        },


        ...mapMutations(['SAVE_PAGE_THIS']),


        /*****************************************
         * @this (initStatus)有批次ID--配置默认数据
         *****************************************/
        async initStatus () {
            if (this.$route.query.id) {
                // (1) 是否有 "批次ID"
                this.isEdit = true
                // (2) 批次 ID
                let id = this.$route.query.id
                // (3) 查询批次数据
                const { data } = await getSinglePlan({planId: id})
                // (4) 表单基本数据配置
                for (let item in this.form) {
                    this.form[item] = data[item] ? data[item] : this.form[item]
                }
                // (5) 是否开启缴费
                this.form.isPay = data.isPay;
                // (6) 所选批次 ID
                this.form.planId = data.id;
                // (7) 报名人工审核
                this.form.form_needAudit = data.needAudit;
                // (8) IP 范围限制
                this.form.form_needIpCheck = data.needIpCheck == 1 ? true : false;
                // (9) 课程列表
                this.form.form_courseIdList = data.courseList.map(item => item.id)
                // (10) 是否下载准考证 
                this.isUploadTicket = JSON.parse(data.isExistEntranceTemp)
                // (11) 缴费二维码
                this.payInfo.imageUrl = data.payPic
                // (12) 缴费详情
                this.payInfo.paymentText = data.payText
                // (13) 缴费方式
                this.payInfo.onlinePayment = data.payType
                // (14) 准考证
                this.entranceFilepath = data.entranceFilepath
                // (15) 考试批次
                this.planCode = data.planCode;
                // 课程费用列表设置
                this.PayMentInfo.needPayCourse = data.courseList;
                // 课程费用, 费用设置
                data.courseList.map( e => {
                    this.PayMentInfo.PayCourse[e.id] = e.money;
                })
                // (16) 是否显示 初审/终审 表单
                this.examTypeChange(data.needAudit);
            }
        },
        async initPlanCode () {
            const { data } = await getPlanCodeFn()
            this.planCode = data
        },
        async initCourseData () {
            const { data } = await getSelectCourse()
            this.courseData = data
        },
        handleCheckedChange (value) {
            this.PayMentInfo.needPayCourse = [];
            this.courseData.map( e => {
                if (value.includes(e.id)) {
                this.PayMentInfo.needPayCourse.push(e);
                }
            })
        },
        async addOrEdit () {
      
            this.$refs['form'].validate(async (valid) => {
                if (valid) {
                    let params = {...this.form}
                    params.courseIdList = params.form_courseIdList.join()
                    params.needAudit = params.form_needAudit ? 1 : 0
                    for (let key in params) {
                        if (key.startsWith('form_')) {
                            delete params[key]
                        }
                    }
                    const dealFn = this.isEdit ? editPlanFn : addPlanFn
                    const { code } = await dealFn(params)
                    if (code ==  1) {
                        this.$otsPopPro({
                            content: this.isEdit ? '修改成功' : '添加成功',
                            cancelName: '返回',
                            okName: '查看'
                        }).then(() => {
                        }).catch(() => {
                            this.goIndex()
                        })
                    }
                } else {
                    return false
                }
            })
        },
        goIndex () {
            this.$router.push({
                name: 'examBatch'
            })
        },
        leftShow () {
            if (this.entranceFilepath) {
                window.open(this.entranceFilepath)
            } else {
                this.$message.error("准考证模板待上传")
            }
        }
    }
}
</script>
<style lang="less" scoped>
/* 线下缴费二维码样式 */
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 131px;
  height: 131px;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 131px;
  height: 131px;
  line-height: 131px;
  text-align: center;
  position: absolute;
  top: 0%;
  left: 0%;
}
.avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
}
.section {
  border-bottom: 1px solid #F1F2F5;
  h4{
    margin-bottom: 30px;
  }
  .sectionBox {
      .lang {
        width: 512px;
      }
        .examType{
        width:120px;
        margin-right: 16px;
        /deep/ .el-radio-button__inner {
            width:100%;
        }
    }
  }
  .stationBox {
      width: 1000px;
      max-height: 300px;
      background-color: #F8F9FC;
      overflow-y: auto;
      padding: 20px;
      border-radius: 8px;
      .stationTop {
        display: flex;
        margin-bottom: 20px;
      }
      .searchCourse {
          position: relative;

          .searchPos {
              width: 40px;
              height: 18px;
              line-height: 18px;
              border-left: 1px solid #E1E6ED;
              position: absolute;
              right: 0;
              top: 11px;
              color: #C2C6CC;
              font-size: 14px;
              i {
                  margin-left: 10px;
                  cursor: pointer;
              }
          }
      }
  }
    .editor {
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        border-radius: 3px;
        padding: 8px;
        width: 800px;
        height: 200px;
        overflow: auto;
    }
  /deep/ .el-form-item {
      margin-bottom: 30px!important;
  }
  /deep/ .el-radio-button__inner {
      margin-right: 16px;
      color: #45494D!important;
      background: #F4F5F8!important;
      font-size: 13px;
      border-radius: 4px!important;
      border: 1px solid #DADDE6!important;
      width: 64px;
      height: 32px;
      line-height: 32px;
      padding: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      background: #EBF5FF!important;
      border: 1px solid #006AFF!important;
      color: #006AFF!important;
      box-shadow:none;
  }
}
.textarea {
    width: 500px;
    height: 80px;
    /deep/ .el-textarea__inner {
        height: 100%;
    }
}
.preBtn:hover .codePreview {
  display: flex;
}
.codePreview {
  bottom: -60px;
  left: 40px;
  width: 405px;
  min-height: 487px;
  background: #ffffff;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid #dadde6;
  border-radius: 4px;
//   position: absolute;
  display: none;
//   display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 32px;
  box-sizing: border-box;
  z-index: 2;
  .picArea {
    width: 280px;
    height: 280px;
    padding: 10px;
    box-sizing: border-box;
    margin: 20px auto;
    img {
      width: 100%;
      height: 100%;
    }
    p {
        text-align: center;
    }
  }
  .payContent {
    width: 100%;
    word-break: break-word;
  }
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
// /deep/ .el-input .el-input__inner {
//   width: 240px;
//   height: 36px;
//   line-height: 18px;
// }
</style>